import { NBSP } from '../../constants/symbols';

export const content = [
  {
    img: 'scales',
    title: `Подберёт квартиру по${NBSP}вашим запросам`,
    text: `Риелтор видит неочевидные плюсы и${NBSP}минусы всех вариантов, а ещё может обратить ваше внимание на квартиры, которые вы по каким-то причинам ранее не рассматривали.`,
  },
  {
    img: 'shield',
    title: `Проверит квартиру и${NBSP}документы`,
    text: `До 7% сделок с недвижимостью могут быть оспорены в дальнейшем. Для покупателя это означает, что при самом плохом сценарии он может потерять и${NBSP}квартиру, и деньги. Риелтор этого не${NBSP}допустит.`,
  },
  {
    img: 'paper',
    title: 'Организует и проведёт сделку',
    text: `Риелтор поможет провести просмотры, соберёт и проверит документы, будет общаться со второй стороной сделки и${NBSP}отстаивать ваши интересы на каждом этапе.`,
  },
];
